<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('segments') }} -> <router-link to="/list-segment">{{ $t('list-segments') }}</router-link> -> {{ this.segment.name }}
    </h1>
    <div class="form-top">
      <div class="form-group group-right">
        <button type="button" class="btn btn-primary" @click="deleteAccept">Удалить сегмент</button>
      </div>
    </div>
    <div class="main__body">
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('filter') }}
        </h1>
        <div class="form-group">
          <label>{{ $t('search') }}</label>
          <input class="large" type="text" :placeholder="$t('search')" v-model="search" v-on:keyup.enter="getClients()">
        </div>
      </div>
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('clients') }} ({{ cClient }})
        </h1>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">
              №
            </th>
            <th scope="col">{{ $t('FIO') }}</th>
            <th scope="col">{{ $t('phone') }} ({{ cClientPhone }})</th>
            <th scope="col">E-mail ({{ cClientEmail }})</th>
            <th scope="col">{{ $t('segment-participant') }}</th>
            <th scope="col">
              <img src="@/assets/social/telegram.svg">
            </th>
            <th scope="col">
              <img src="@/assets/social/viber.svg">
            </th>
            <th scope="col">
              <img src="@/assets/social/email.svg">
            </th>
            <th scope="col">
              <img src="@/assets/social/sms.svg">
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in clients" v-bind:key="item.id">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td class="pointer" v-on:click.self="showClientModal(item.id)">{{ (item.middlename ? item.middlename : '') + ' ' + (item.firstname ? item.firstname : '') + ' ' + (item.lastname ? item.lastname : '') }}</td>
            <td v-if="item.phone"><img src="@/assets/icon/check.svg"></td>
            <td v-else><img src="@/assets/icon/cross.svg"></td>
            <td v-if="item.email"><img src="@/assets/icon/check.svg"></td>
            <td v-else><img src="@/assets/icon/cross.svg"></td>
            <td>{{ item.segmentCount }}</td>
            <td>{{ item.telegramCount }}</td>
            <td>{{ item.viberCount }}</td>
            <td>{{ item.emailCount }}</td>
            <td>
              {{ item.smsCount }}
              <label class="table__td-trash pointer" @click="deleteClientFromSegment(item.id, item.middlename, item.firstname, item.lastname)">
                <img src="@/assets/icon/trash.svg">
              </label>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="form-row justify-content-center" v-if="clients.length < cClient && search === null || search === ''">
          <a class="btn" @click="nextPage">{{ $t('show-more') }}</a>
        </div>
        <div class="form-row mb-2">
          <a class="btn btn-primary" @click="showModalAddClientInSegment">Добавить клиента в сегмент</a>
        </div>
      </div>
    </div>
    <clientModal :id="selectUser" v-show="isModalClientVisible"
                 @close="closeClientModal"/>
    <remove-segment-modal :segment="this.deleteSegment" v-show="isModalDeleteSegmentVisible"
                          @close="closeModalDeleteSegmentVisible"></remove-segment-modal>
    <remove-client-from-segment :client="this.deleteClient" :segment="this.segment"
                                v-show="isModalDeleteClientFromSegment"
    @close="closeModalDeleteClientFromSegment"></remove-client-from-segment>
    <add-client-in-segment-modal :segment="this.$route.params.id" v-show="isModalAddClientInSegment"
                                 @close="closeModalAddClientInSegment">
    </add-client-in-segment-modal>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>

import axios from "axios";
import loading from "vue-loading-overlay";
import clientModal from "../../components/modal/clientModal";
import RemoveSegmentModal from "../../components/modal/segment/remove-segment-modal";
import AddClientInSegmentModal from "../../components/modal/segment/add-client-in-segment-modal";
import RemoveClientFromSegment from "../../components/modal/segment/remove-client-from-segment";

export default {
  name: 'view-segment',
  data: function () {
    return {
      selectUser: 0,
      deleteSegment: {
        id: 0,
        name: ''
      },
      deleteClient: {
        id: 0,
        firstname: '',
        middlename: '',
        lastname: '',
      },
      dynamicSearch: {
        searchVarChar: {},
        searchDouble: {},
        searchDate: {},
      },
      cClient: 0,
      cClientEmail: 0,
      cClientPhone: 0,
      page: 1,
      search: null,
      segment: [],
      clients: [],
      isLoading: false,
      fullPage: true,
      isModalDeleteClientFromSegment: false,
      isModalAddClientInSegment: false,
      isModalClientVisible: false,
      isModalDeleteSegmentVisible: false,
    }
  },
  created: function () {
    this.getSegment();
  },
  mounted() {
    this.$root.$on('viewSegmentUpdateClients', () => {
      this.getClients();
    });
  },
  methods: {
    nextPage: function(){
      this.page++;
      this.getClients();
    },
    getSegment: function () {
      this.isLoading = true;
      axios.post('getSegment', this.$route.params.id).then(response => {
        var status = response.data.status;
        if(status){
          this.segment = response.data.segment;
          this.isLoading = false;
          this.getClients();
        }
      });
    },
    getClients: function() {
      this.isLoading = true;
      var data = {
        segment_id: this.$route.params.id,
        search: this.search,
        dynamicSearch: this.dynamicSearch,
        page: this.page
      }
      axios.post('getClients', data).then(response => {
        var status = response.data.status;
        if(status){
          this.clients = response.data.clients;
          this.cClient = response.data.cClient;
          this.cClientEmail = response.data.cClientEmail;
          this.cClientPhone = response.data.cClientPhone;
          this.isLoading = false;
        }
      });
    },
    deleteAccept: function(){
      this.deleteSegment.id = this.segment.id;
      this.deleteSegment.name = this.segment.name;
      this.showModalDeleteSegmentVisible();
    },
    deleteClientFromSegment: function(clientId, middlename, firstname, lastname){
      this.deleteClient.id = clientId;
      this.deleteClient.middlename = middlename;
      this.deleteClient.firstname = firstname;
      this.deleteClient.lastname = lastname;
      this.showModalDeleteClientFromSegment();
    },
    showModalDeleteClientFromSegment() {
      this.isModalDeleteClientFromSegment = true;
    },
    closeModalDeleteClientFromSegment() {
      this.isModalDeleteClientFromSegment = false;
    },
    showModalDeleteSegmentVisible() {
      this.isModalDeleteSegmentVisible = true;
    },
    closeModalDeleteSegmentVisible() {
      this.isModalDeleteSegmentVisible = false;
    },
    showModalAddClientInSegment() {
      this.isModalAddClientInSegment = true;
    },
    closeModalAddClientInSegment() {
      this.isModalAddClientInSegment = false;
    },
    showClientModal(id) {
      this.selectUser = id;
      this.isModalClientVisible = true;
    },
    closeClientModal() {
      this.isModalClientVisible = false;
    }
  },
  components: {
    RemoveClientFromSegment,
    AddClientInSegmentModal, loading, clientModal, RemoveSegmentModal
  }
}

</script>